import { render, staticRenderFns } from "./OnboardingDesktop.vue?vue&type=template&id=3b51c945"
import script from "./OnboardingDesktop.vue?vue&type=script&lang=js"
export * from "./OnboardingDesktop.vue?vue&type=script&lang=js"
import style0 from "./OnboardingDesktop.vue?vue&type=style&index=0&id=3b51c945&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports